<template>
  <div class="page" id="detail">
    <div id="video-container">
      <video
        ref="video"
        id="video"
        class="video-video"
        controls
        playsinline
        webkit-playsinline
        :src="course_data.videos[curVid].videourl"
        :poster="course_data.videos[curVid].poster"
      ></video>
    </div>

    <div class="list">
      <img
        :src="
          $route.query.id <= 5
            ? require(`@/assets/nav${$route.query.id}.png`)
            : require('@/assets/NavIaap.png')
        "
        alt=""
        class="title"
        :class="$route.query.id <= 5 ? 'tit1' : 'tit2'"
      />

      <div class="rules" :class="hideRule?'hideRule':''" v-if="!$global.type && course_data.course.rules">
        
        <p>课程详情 : {{course_data.course.rules}}</p>
        <img src="@/assets/ruleShow.png" alt="" @click="hideRule = !hideRule">
      </div>

      <div
        class="item"
        v-for="(item, index) in course_data['videos']"
        :key="index"
        @click="changeVideo(index)"
      >
        <img :src="item.poster" alt="" class="poster" />
        <div class="title">{{ item.title }}</div>
      </div>
    </div>

    <!-- <video-player :options="videoOptions"/> -->

    <img
      @click="
        $router.push({
          path: '/upload',
          query: { id: id, uploadtype: course_data.course.uploadtype },
        })
      "
      v-if="!$global.type && $route.query.id > 5"
      class="btn-uploading"
      src="@/assets/btn-UpLoading.png"
      alt=""
      width="676"
      height="100"
    />

    <Comment :cid="$route.query.id"></Comment>
  </div>
</template>

<script>
import index from "./index.js";
export default { ...index };
</script>

<style lang="scss">
@import "./index.scss";
</style>